import { Button, Flex, Spinner } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import {
  PLAN_REVAMP_RADIUS_SM,
  PLAN_TEXT,
  controlHeight,
} from 'pages/PlanRevamp/PlanPageUIRevamp/planPageRevampUi';
import {
  clearStepperFormData,
  handleActionStepPrevious,
  setClearSelectedAreasTable,
} from 'redux/DataImportSlice';

import colors from '../dataTheme';

interface Properties {
  isSubmitting?: boolean;
  prevButtonName: string;
  nextButtonName: string;
  setactionCreate?: any;
  disableNext?: boolean;
}

const buttonBase = {
  h: controlHeight,
  px: 4,
  minW: '84px',
  borderRadius: PLAN_REVAMP_RADIUS_SM,
  ...PLAN_TEXT.toolbarTab,
  textTransform: 'none',
  width: 'fit-content',
  boxShadow: 'none',
} as const;

const ActionStepFooter = ({
  prevButtonName,
  nextButtonName,
  isSubmitting,
  setactionCreate,
  disableNext = false,
}: Properties) => {
  const dispatch: any = useDispatch();
  const activeActionStep = useSelector((state: any) => state.dataImportSlice.actionSteps);

  return (
    <Flex gap={2} alignItems='center'>
      {activeActionStep !== 0 && (
        <Button
          {...buttonBase}
          variant='outline'
          borderColor={colors.border}
          bg={colors.surface}
          color={colors.textDark}
          _hover={{ bg: colors.hover }}
          onClick={() => {
            if (prevButtonName === 'CANCEL' || activeActionStep === 0) {
              dispatch(clearStepperFormData());
              setactionCreate(false);
            } else if (activeActionStep === 2) {
              dispatch(setClearSelectedAreasTable());
              dispatch(handleActionStepPrevious());
            } else {
              dispatch(handleActionStepPrevious());
            }
          }}
        >
          {prevButtonName}
        </Button>
      )}

      <Button
        {...buttonBase}
        type='submit'
        isDisabled={isSubmitting || disableNext}
        bg={colors.action}
        color={colors.white}
        _hover={{ bg: colors.actionHover, _disabled: { bg: colors.action } }}
        _active={{ bg: colors.actionHover }}
        _disabled={{ opacity: 0.4, cursor: 'not-allowed' }}
      >
        {nextButtonName}
        {isSubmitting && <Spinner ml={2} size='xs' />}
      </Button>
    </Flex>
  );
};
export default ActionStepFooter;
